import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { initializeEncryptedBrowserStorage } from './app/shared/services/encrypted-browser-storage';
import { environment } from './environments/environment';

initializeEncryptedBrowserStorage(environment.storageEncryption.enabled);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
